import React from 'react'


const EventListTitle = ({ setSortMethod,eventsPage,setEventsPage,pageEnd }) => {



    return (
        <div className="container d-flex align-items-center justify-content-between mt-2">
            <span className="lead text-center mb-2 mt-2">Browse Events</span>
            <div className="d-flex align-items-center">
                <span className="muted">Sort by: &nbsp;</span>
                <span className="sortOption">
                    <i className="fa-solid fa-chevron-down"></i>
                    <select className="form-control" onChange={(e) => setSortMethod(e.target.value)} style={{ width: "180px", marginLeft: 0 }}>
                        <option value="alumniName">Name</option>
                        <option value="alumniPassedOut">Batch</option>
                        <option value="alumniDepartment">Department</option>
                        <option value="eventPurpose">Purpose of Event</option>
                        <option value="eventStartDate">Start Date</option>
                        <option value="conductedBy">Conducted By</option>
                    </select>
                </span>

                <div  className='d-flex'>
                    <button onClick={() => setEventsPage(eventsPage - 1)} className={'paginationBTN btn mt-2 mb-2 ' + (eventsPage == 0 ? 'disabled' : 'enabled')}>
                        <i className="fa-solid fa-chevron-left"></i> Prev
                    </button>
                    <input type="number" value={eventsPage + 1} className="form-control mt-2 mb-2" id="eventsPageNo" style={{ width: '50px' }} />
                    <button onClick={() => setEventsPage(eventsPage + 1)} className={'paginationBTN btn mt-2 mb-2 ' + (pageEnd == true ? 'disabled' : 'enabled')}>
                        Next <i className="fa-solid fa-chevron-right"></i>
                    </button>
                </div>

            </div>
        </div>
    );
}

export default EventListTitle;